import axiosInstance from '../axiosConfig';

const CACHE_TTL_MS = 60 * 1000;
const modalDataCache = new Map();
const modalDataPromiseCache = new Map();

const normalizeFilters = (filters = {}) => ({
    project: filters.project || '',
    upgrade: filters.upgrade || '',
    storage_location: filters.storage_location || '',
    compatibility: Array.isArray(filters.compatibility)
        ? [...filters.compatibility].map(String).sort()
        : [],
});

const getCacheKey = (serviceCenterId, filters) => (
    `${serviceCenterId || 'default'}:${JSON.stringify(normalizeFilters(filters))}`
);

export const clearComponentModalDataCache = (serviceCenterId = null) => {
    if (!serviceCenterId) {
        modalDataCache.clear();
        modalDataPromiseCache.clear();
        return;
    }

    const prefix = `${serviceCenterId}:`;
    [...modalDataCache.keys()].forEach((key) => {
        if (key.startsWith(prefix)) {
            modalDataCache.delete(key);
        }
    });
    [...modalDataPromiseCache.keys()].forEach((key) => {
        if (key.startsWith(prefix)) {
            modalDataPromiseCache.delete(key);
        }
    });
};

export const getComponentModalData = async ({
    authToken,
    serviceCenterId,
    filters = {},
}) => {
    const cacheKey = getCacheKey(serviceCenterId, filters);
    const cachedEntry = modalDataCache.get(cacheKey);

    if (cachedEntry && (Date.now() - cachedEntry.createdAt) < CACHE_TTL_MS) {
        return cachedEntry.data;
    }

    let requestPromise = modalDataPromiseCache.get(cacheKey);
    if (!requestPromise) {
        requestPromise = axiosInstance.get('/api/component-modal-data/', {
            headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
            params: normalizeFilters(filters),
        }).then((response) => {
            modalDataCache.set(cacheKey, {
                createdAt: Date.now(),
                data: response.data,
            });
            return response.data;
        }).finally(() => {
            modalDataPromiseCache.delete(cacheKey);
        });
        modalDataPromiseCache.set(cacheKey, requestPromise);
    }

    return requestPromise;
};
